export default "__VITE_ASSET__DVV9qqdc__"